export default {
  selectedSchool: state => state.selectedSchool
}
